<template>
  <div>
    <LoadingSpinner v-if="loading" class="my-6 mx-20" />
    <div v-else-if="!showError && !success">
      <h1 class="font-extrabold text-2xl my-4 text-primary dark:text-primary-200 tracking-wide">
        {{ promptHeader }}
      </h1>
      <h2 class="w-full mb-6 sm:w-3/4 mx-auto text-xl font-semibold">
        {{ promptMsg }}
      </h2>
      <div class="flex w-full justify-center mb-8">
        <div class="w-4/5 flex h-12">
          <VButton
            v-for="option of acceptanceOptions"
            :key="option"
            :label="option"
            @click="submit(option)"
            :outlined="option === acceptanceOptions[0]"
            :disabled="option === acceptanceOptions[1] && submitting"
            :submitting-prepend="option === acceptanceOptions[1] && submitting"
            uppercase
            class="p-2 mx-1"
            :class="canSetToAwaiting ? 'w-1/2' : 'w-full'"
          />
        </div>
      </div>
    </div>
    <div v-else-if="success">
      <p class="text-success text-lg font-semibold mx-8 my-4">
        Successfully set status to AWAITING!
      </p>
      <VButton
        label="Close" uppercase
        @click="closePrompt"
        class="mx-auto my-6"
      />
    </div>
    <div v-else-if="showError">
      <p class="text-danger text-lg font-semibold mx-8 my-4">
        Error
      </p>
      <VButton
        label="Back" uppercase
        @click="showError = false"
        class="mx-auto my-6"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"
import VButton from "@/components/Buttons/Button/VButton.vue"
import LoadingSpinner from "@/components/Loading/LoadingSpinner/LoadingSpinner.vue"
import { getPOStates, putPurchaseOrderEdit } from "../../../Site-Track/services/PurchaseOrders"

export default {
  name: "ReceiptStatusCheckPrompt",
  components: {
    VButton,
    LoadingSpinner
  },
  data() {
    return {
      loading: true,
      availableStates: [],
      submitting: false,
      showError: false,
      success: false
    }
  },
  computed: {
    ...mapState(["headers"]),
    ...mapGetters(["getProceedArgs"]),
    receiptId() {
      return this.getProceedArgs.id
    },
    canSetToAwaiting() {
      return !this.loading && this.availableStates.includes("AWAITING")
    },
    promptHeader() {
      return this.canSetToAwaiting
        ? "Are you sure?"
        : "Sorry"
    },
    promptMsg() {
      return this.canSetToAwaiting
        ? 'Selecting this PO will change its status to "Awaiting".'
        : 'This PO cannot be selected, since its status cannot be set to "AWAITING".'
    },
    acceptanceOptions() {
      return this.canSetToAwaiting ? ["Cancel", "Proceed"] : ["Close"]
    }
  },
  mounted() {
    this.loadStates()
  },
  methods: {
    ...mapMutations(["closePrompt", "setRefreshStatus", "setPrompt"]),
    async loadStates() {
      await getPOStates(this.receiptId, this.headers)
      .then(response => {
        if (response.status === 200) {
          this.availableStates = response.data.results
        }
        else {
          this.showError = true
          console.log(response)
        }
      }).catch(error => {
        this.showError = true
        console.log(error)
      })
      this.loading = false
    },
    submit(option) {
      if (option === this.acceptanceOptions[1]) this.setStatusToAwaiting()
      else this.closePrompt()
    },
    async setStatusToAwaiting() {
      let requestBody = {
        status: "AWAITING",
        siteId: this.headers.siteId
      }
      this.submitting = true
      await putPurchaseOrderEdit(this.receiptId, requestBody, this.headers)
      .then(response => {
        if (response.status === 200) {
          this.success = true
          this.setRefreshStatus({ [this.receiptId]: "AWAITING" })
          this.closePrompt()
        }
        else {
          console.log(response)
          this.showError = true
          if (response.status === 403) {
            this.setPrompt(["You do not have the required permissions for this action.", "closePrompt", null, { header: "Error" }])
          }
        }
      }).catch(error => {
        console.log(error)
        this.showError = true
      })
      this.submitting = false
    }
  },
}
</script>